import { render, staticRenderFns } from "./wenda.vue?vue&type=template&id=88d117f4"
import script from "./wenda.vue?vue&type=script&lang=js"
export * from "./wenda.vue?vue&type=script&lang=js"
import style0 from "./wenda.vue?vue&type=style&index=0&id=88d117f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports